var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageLogsMoreContactsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.182,
    height: 10.865,
    viewBox: "0 0 14.182 10.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160314",
    "data-name": "Group 160314",
    transform: "translate(-407.673 -386.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M14.033,5.356a1.808,1.808,0,0,1,1.919,1.672A1.808,1.808,0,0,1,14.033,8.7a1.808,1.808,0,0,1-1.92-1.673A1.808,1.808,0,0,1,14.033,5.356Z",
    transform: "translate(403 382)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M7.885,7.038a1.522,1.522,0,0,1,1.909.508A1.154,1.154,0,0,1,9.21,9.208,1.523,1.523,0,0,1,7.3,8.7,1.155,1.155,0,0,1,7.885,7.038Z",
    transform: "translate(403 381.801)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M14.032,11.575A4.007,4.007,0,0,0,9.974,15a.427.427,0,0,0,.243.513.306.306,0,0,0,.088.016h7.454A.393.393,0,0,0,18.1,15.1a.5.5,0,0,0-.014-.1A4.009,4.009,0,0,0,14.032,11.575Z",
    transform: "translate(403 381.196)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M10.454,12.15a3.708,3.708,0,0,0-4.472.687,2.276,2.276,0,0,0-.559,1.472v.209a11.636,11.636,0,0,0,3.207.444c.268,0,.537-.009.805-.026",
    transform: "translate(403 381.18)",
    fill: "none",
    stroke: "#0d0d0d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLogsMoreContactsIcon);
export default __webpack_public_path__ + "static/media/message-logs-more-contacts-icon.7471a52a21f2d8799cae8dea45e0130c.svg";
export { ForwardRef as ReactComponent };